import { Content } from "@/@types/general";

import MovieCard from "../cards/MovieCard";

export interface MoviesGridProps {
  content: Content[];
}

const MoviesGrid = ({ content }: MoviesGridProps) => {
  return (
    <>
      <div className={"movies-grid fixed left-[110%] top-0 z-[-1] w-full px-10 max-lg:px-4"}>
        <MovieCard {...content[0]} />
      </div>
      <div className={"mt-[30px] max-lg:mt-3"} style={{ position: "relative" }}>
        <div className="movies-grid">
          {content.map((item) => (
            <MovieCard key={item.id} {...item} />
          ))}
        </div>
      </div>
    </>
  );
};

export default MoviesGrid;
